var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.754,
    height: 63.864,
    viewBox: "0 0 71.754 63.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(313 -876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M-254.6,931.2a3.378,3.378,0,0,1-2.526-1.132l-12.021-13.524a3.381,3.381,0,0,1,.281-4.773,3.381,3.381,0,0,1,4.773.281l8.7,9.783a82.165,82.165,0,0,1,36.152-33.5,3.381,3.381,0,0,1,4.51,1.587,3.381,3.381,0,0,1-1.587,4.51c-25.82,12.379-35.054,34.44-35.144,34.662a3.387,3.387,0,0,1-2.561,2.059A3.37,3.37,0,0,1-254.6,931.2Z",
    transform: "translate(-26.846 -7.491)",
    fill: "#385CAD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-313 876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M-260.03,939.864h-42.075A10.907,10.907,0,0,1-313,928.97V886.895A10.907,10.907,0,0,1-302.106,876h42.075a3.381,3.381,0,0,1,3.381,3.381,3.381,3.381,0,0,1-3.381,3.381h-42.075a4.137,4.137,0,0,0-4.132,4.132V928.97a4.137,4.137,0,0,0,4.132,4.132h42.075a4.137,4.137,0,0,0,4.132-4.132V902.536a3.381,3.381,0,0,1,3.381-3.381,3.381,3.381,0,0,1,3.381,3.381V928.97A10.907,10.907,0,0,1-260.03,939.864Z",
    transform: "translate(313 -876)",
    fill: "#385CAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirmIcon.6f3551a105e10be0aef439e3d19e762b.svg";
export { ForwardRef as ReactComponent };